<template>
  <div>
    <div class="mc__cards">
      <div class="mc__card-wrapper mc__card-wrapper--basic">
        <div class="mc__card mc__card--basic">
          <div class="mc__title mc__title--basic">
            Free
          </div>
          <div class="mc__price-info">
            <div class="mc__currency">
              $
              <div class="mc__currency--asia">
                US
              </div>
            </div>
            <span class="mc__price">0</span>
          </div>
          <div class="mc__single-user mc__single-user--40" />
          <div class="mc__plan-info-title">
            No credit card needed
          </div>
          <div class="mc__plan-info">
            <span>
              Up to <b>7</b> live participants
              <br>Unlimited question
              <br>Unlimited quiz
              <br>Unlimited Q&A
              <br>
              <br>
            </span>
          </div>
        </div>
      </div>
      <div class="mc__card-wrapper mc__card-wrapper--yellow">
        <div class="mc__card mc__card--yellow">
          <div class="mc__title mc__title--yellow">
            Essential
          </div>
          <div class="mc__price-info">
            <div class="mc__currency">
              $
              <div class="mc__currency--asia">
                US
              </div>
            </div>
            <span class="mc__price">7</span>
            <span class="mc__price mc__smaller-price">95</span>
            <div>
              <div class="mc__billing">
                / month
              </div>
            </div>
          </div>
          <div class="mc__single-user" />
          <div class="mc__plan-info-title">
            All Free plus:
          </div>
          <div class="mc__plan-info">
            <span>
              Up to <b>50</b> live participants
              <br>Participant data export
              <br>
            </span>
            <span class="mc__more" @click="$emit('learnmore')">Learn more...</span>
            <br>
            <br>
          </div>
          <button
            class="action-button action-button--yellow"
            type="button"
            :disabled="permission.essentialYearly"
            @click="$emit('upgradePlan', 'essential-yearly')"
          >
            Upgrade
          </button>
        </div>
      </div>
      <div class="mc__card-wrapper mc__card-wrapper--green">
        <div class="mc__card mc__card--green">
          <div class="mc__title mc__title--green">
            Plus
          </div>
          <div class="mc__price-info">
            <div class="mc__currency">
              $
              <div class="mc__currency--asia">
                US
              </div>
            </div>
            <span class="mc__price">10</span>
            <span class="mc__price mc__smaller-price">95</span>
            <div>
              <div class="mc__billing">
                / month
              </div>
            </div>
          </div>
          <div class="mc__single-user" />
          <div class="mc__plan-info-title">
            All Free plus:
          </div>
          <div class="mc__plan-info">
            <span>
              Up to <b>200</b> live participants
              <br>Participant data export
              <br>
            </span>
            <span class="mc__more" @click="$emit('learnmore')">Learn more...</span>
            <br>
            <br>
          </div>
          <button
            class="action-button action-button--green"
            type="button"
            :disabled="permission.plusYearly"
            @click="$emit('upgradePlan', 'plus-yearly')"
          >
            Upgrade
          </button>
        </div>
      </div>
      <div class="mc__card-wrapper mc__card-wrapper--purple">
        <div class="mc__card mc__card--purple">
          <div class="mc__title mc__title--purple">
            Pro
          </div>
          <div class="mc__price-info">
            <div class="mc__currency">
              $
              <div class="mc__currency--asia">
                US
              </div>
            </div>
            <span class="mc__price">15</span>
            <span class="mc__price mc__smaller-price">95</span>
            <div>
              <div class="mc__billing">
                / month
              </div>
            </div>
          </div>
          <div class="mc__single-user" />
          <div class="mc__plan-info-title">
            All Free plus:
          </div>
          <div class="mc__plan-info">
            <span>
              Up to <b>10,000</b> live participants
              <br>Participant data export
              <br>Have your own branding
              <br>
            </span>
            <span class="mc__more" @click="$emit('learnmore')">Learn more...</span>
          </div>
          <button
            class="action-button action-button--purple"
            type="button"
            :disabled="permission.proYearly"
            @click="$emit('upgradePlan', 'pro-yearly')"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    permission: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.mc__cards {
  min-height: 400px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.mc__card-wrapper {
  margin-top: 50px;
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
}

.mc__card-wrapper--green {
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 1;
  margin-top: 35px;
}

.mc__card {
  padding-top: 35px;
  padding-bottom: 36px;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15),
    0 1px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  z-index: 2;
}

.mc__card--basic {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.mc__card--yellow {
  border-radius: 10px 0 0 10px;
  background-color: #fff;
}

.mc__card--green {
  padding-top: 50px;
  padding-bottom: 52px;
  border-radius: 10px 10px 10px 10px;
  z-index: 3;
  background-color: #fff;
}

.mc__card--purple {
  border-radius: 0 10px 10px 0;
  background-color: #fff;
}

.mc__title {
  font-size: 26px;
  margin-bottom: 15px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: bold;
}

.mc__title--yellow {
  color: #ffae09;
}

.mc__title--green {
  color: #28c270;
}

.mc__title--purple {
  color: #7669bf;
}

.mc__price-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-bottom: 5px;
}

.mc__currency {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.6);
  padding-right: 5px;
}

.mc__currency--asia {
  font-size: 10px;
}

.mc__price {
  font-weight: bold;
  font-size: 32px;
  color: rgba(0, 0, 0, 0.6);
  padding-right: 6px;
}

.mc__smaller-price {
  font-size: 14px;
  margin-top: -19px;
  margin-left: -5px;
}

.mc__billing {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
}

.mc__single-user {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
  padding-bottom: 25px;
  min-height: 18px;
}

.mc__plan-info-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
  padding-bottom: 10px;
  &.one-line {
    padding-bottom: 37px;
  }
}

.mc__more {
  text-decoration: none;
  color: $primary-color;
  cursor: pointer;
}

.mc__more {
  &:hover,
  &:active,
  &:focus {
    color: $primary-hover-color;
  }
}

.mc__plan-info {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
  padding-bottom: 15px;
  line-height: 1.3;
}

.action-button {
  border-radius: 20px;
  border: 0;
  color: #fff;
  cursor: pointer;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: 0.15s linear;
}

.action-button:focus {
  outline: none;
}

.action-button--basic {
  background-color: #808080;
}

.action-button--basic:hover {
  box-shadow: 0 1px 10px rgba(128, 128, 128, 0.4);
}

.action-button--green {
  background-color: #28c270;
}

.action-button--green:hover {
  box-shadow: 0 1px 10px rgba(40, 194, 112, 0.4);
}

.action-button--yellow {
  background-color: #ffae09;
}

.action-button--yellow:hover {
  box-shadow: 0 1px 10px rgba(255, 174, 9, 0.4);
}

.action-button--purple {
  background-color: #7669bf;
}

.action-button--purple:hover {
  box-shadow: 0 1px 10px rgba(118, 105, 191, 0.4);
}

//Mobile
.mct {
  background: -o-radial-gradient(center, ellipse, #e6e6e6 0%, #fff 70%);
  background: radial-gradient(ellipse at center, #e6e6e6 0%, #fff 70%);
}

@media (min-width: 540px) {
  .mct {
    padding: 20px;
  }
}

.mct-card {
  background-color: #fff;
  padding: 20px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 539px) {
  .mct-card {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}

@media (min-width: 540px) {
  .mct-card {
    border-radius: 5px;
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    margin-bottom: 15px;
  }
}

@media (max-width: 479px) {
  .action-button {
    font-size: 11px;
    width: 120px;
    font-weight: bold;
  }
}

@media (min-width: 480px) {
  .action-button {
    font-size: 12px;
    padding: 0 20px;
    font-weight: bold;
    height: 35px;
    line-height: 37px;
  }
}

button {
  cursor: pointer;
  width: 110px;
}

button:disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}
@media (max-width: 500px) {
  .mct-card {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
